export default "__VITE_ASSET__aef2ed02__"